import React from "react";
import clsx from "clsx";

const Button = ({ text, onClick, styles, type, disabled, textStyles }) => {
  return (
    <button
      className={clsx(
        "h-14 w-full max-w-[300px] rounded-2xl px-6 py-2 text-white",
        styles ? styles : "bg-btnBlue hover:bg-btnBlueHover",
        disabled && "opacity-40",
      )}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      <p className={textStyles}>{text}</p>
    </button>
  );
};

export default Button;
